import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const TimesIcon = ({ label = 'Times', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="m61.6 203.7 38.1 38.1 44.6-44.6a5 5 0 0 1 7.1 0l44.6 44.6 38.1-38.1-44.6-44.6a5 5 0 0 1 0-7.1l44.6-44.6L196 69.3l-44.6 44.6a5.1 5.1 0 0 1-7.1 0L99.7 69.3l-38.1 38.1 44.6 44.6a5.1 5.1 0 0 1 0 7.1z" style="fill:#ef8975"/><path d="m196 69.3 38.1 38.1-44.6 44.6a5 5 0 0 0 0 7.1l44.6 44.6-38.1 38.1-44.6-44.6a5.1 5.1 0 0 0-3.6-1.5 4.9 4.9 0 0 0-3.5 1.5l-44.6 44.6-38.1-38.1 44.6-44.6a5.1 5.1 0 0 0 0-7.1l-44.6-44.6 38.1-38.1 44.6 44.6a4.9 4.9 0 0 0 3.5 1.5 5.1 5.1 0 0 0 3.6-1.5L196 69.3m0-10a9.9 9.9 0 0 0-7.1 2.9l-41.1 41.1-41-41.1a10.1 10.1 0 0 0-7.1-2.9 9.9 9.9 0 0 0-7.1 2.9l-38.1 38.1a10.1 10.1 0 0 0 0 14.2l41.1 41-41.1 41.1a9.9 9.9 0 0 0-2.9 7.1 9.7 9.7 0 0 0 2.9 7l38.1 38.2a10.3 10.3 0 0 0 7.1 2.9 10.5 10.5 0 0 0 7.1-2.9l41-41.1 41.1 41.1a10.3 10.3 0 0 0 7.1 2.9 10.1 10.1 0 0 0 7-2.9l38.1-38.2a10 10 0 0 0 0-14.1l-41-41.1 41-41a10.1 10.1 0 0 0 0-14.2L203 62.2a9.7 9.7 0 0 0-7-2.9z" style="fill:#1d1d1b"/><path d="M166.3 120.1a5.1 5.1 0 0 1 0-7.1l19.9-19.8a5 5 0 0 1 7 0 5 5 0 0 1 0 7.1l-19.8 19.8a5 5 0 0 1-7.1 0zM89.5 95.3a5 5 0 0 1 0-7.1l7.3-7.3a5 5 0 0 1 7.1 7.1l-7.3 7.3a5.1 5.1 0 0 1-7.1 0zm-10.6 10.9a5.1 5.1 0 0 1 0-7.1l.6-.6a5 5 0 0 1 7.1 7.1l-.6.6a5.1 5.1 0 0 1-7.1 0z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

TimesIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { TimesIcon }
